// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__dCDNQ","calendarButtons":"ClockData_calendarButtons__eeDJV"};